/* @flow */

export enum EditMode {
  Hidden,
  ShowOnHover,
  ShowAlways,
}

export enum DisplayNamePlacement {
  Hidden,
  Bottom,
  Right,
}

export enum AvatarSize {
  Big,
  Medium,
  Small,
}
